// Auto-generated from segment.spec.js
export default {
  "tagName": "ui-segment",
  "types": [
    "emphasis",
    "vertical",
    "raised",
    "stacked",
    "piled"
  ],
  "variations": [
    "attached",
    "padded",
    "inline",
    "compact",
    "color",
    "circular",
    "clearing",
    "floated",
    "text-align",
    "basic"
  ],
  "states": [
    "disabled",
    "loading"
  ],
  "attributes": [
    "emphasis",
    "vertical",
    "raised",
    "stacked",
    "piled",
    "disabled",
    "loading",
    "attached",
    "padded",
    "inline",
    "compact",
    "color",
    "circular",
    "clearing",
    "floated",
    "text-align",
    "basic"
  ],
  "optionAttributes": {
    "primary": "emphasis",
    "secondary": "emphasis",
    "tertiary": "emphasis",
    "top-attached": "attached",
    "attached": "attached",
    "bottom-attached": "attached",
    "padded": "padded",
    "very": "padded",
    "compact": "compact",
    "red": "color",
    "orange": "color",
    "yellow": "color",
    "olive": "color",
    "green": "color",
    "teal": "color",
    "blue": "color",
    "violet": "color",
    "purple": "color",
    "pink": "color",
    "brown": "color",
    "grey": "color",
    "black": "color",
    "left": "floated",
    "right": "floated",
    "left-aligned": "text-align",
    "center-aligned": "text-align",
    "right-aligned": "text-align",
    "very-padded": "padded",
    "very-compact": "compact"
  },
  "propertyTypes": {
    "emphasis": "string",
    "vertical": "boolean",
    "raised": "boolean",
    "stacked": "boolean",
    "piled": "boolean",
    "disabled": "boolean",
    "loading": "boolean",
    "attached": "string",
    "padded": "string",
    "inline": "boolean",
    "compact": "string",
    "color": "string",
    "circular": "boolean",
    "clearing": "boolean",
    "floated": "string",
    "text-align": "string",
    "basic": "boolean"
  },
  "allowedValues": {
    "emphasis": [
      "primary",
      "secondary",
      "tertiary"
    ],
    "attached": [
      "top-attached",
      "attached",
      "bottom-attached"
    ],
    "padded": [
      "padded",
      "very"
    ],
    "compact": [
      "compact",
      "very"
    ],
    "color": [
      "red",
      "orange",
      "yellow",
      "olive",
      "green",
      "teal",
      "blue",
      "violet",
      "purple",
      "pink",
      "brown",
      "grey",
      "black"
    ],
    "floated": [
      "left",
      "right"
    ],
    "text-align": [
      "left-aligned",
      "center-aligned",
      "right-aligned"
    ]
  },
  "attributeClasses": [
    "emphasis",
    "attached",
    "color"
  ],
  "inheritedPluralVariations": [
    "compact",
    "basic"
  ]
};
